import { useState } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';
import NotificationPopup from '../../../../../NotificationPopup';
import { HealtheraButton, InputField } from '../../../../../../healtheraComponents';
import coreApi from '../../../../../../apis/core';
import { useForm } from './useForm';

const DeliveryForm = ({ pharmacy, order, onConfirm, onComplete }) => {
  const handleAssignAction = async (deliveryAddress) => {
    try {
      const updatedOrder = await coreApi.assignPharmacyToOrder(order._id, pharmacy.pharmacy_id, 'delivery', deliveryAddress);
      onComplete(updatedOrder);
      onConfirm();
    } catch (error) {
      setAssignError(error?.message || error?.text || error || 'Can not assign that pharmacy');
    }
  };

  const { handleSubmit, values, errors, isValid, touched, handleChange } = useForm(handleAssignAction);

  const [assignError, setAssignError] = useState(null);
  const {
    pharmacy_name: pharmacyName,
    chain: { name: organisationName } = {},
    postcode: pharmacyPostcode,
    pharmacy_address: pharmacyAddress,
  } = pharmacy || {};

  return (
    <Container>
      <NotificationPopup isOpen={!!assignError} message={assignError} />
      <Block>
        <BlockTitle>Assign to</BlockTitle>
        <PharmacyName>{pharmacyName}</PharmacyName>
        <OrganisationName>{organisationName}</OrganisationName>
        <Postcode>{pharmacyPostcode}</Postcode>
        <Address>{pharmacyAddress}</Address>
      </Block>
      <Block>
        <BlockTitle>Address</BlockTitle>
        <InputField
          label="Address line 1"
          name="line_1"
          value={values.line_1}
          onChange={handleChange}
          helperText={touched.line_1 && errors.line_1}
          error={!!errors.line_1 && touched.line_1}
          margintop={'5px'}
        />
        <InputField
          label="Address line 2"
          name="line_2"
          value={values.line_2 || ''}
          onChange={handleChange}
          helperText={touched.line_2 && errors.line_2}
          error={!!errors.line_2 && touched.line_2}
          margintop={'5px'}
        />
        <DeliveryAddressBlock>
          <AddressInput
            helperText={touched.postcode && errors.postcode}
            label="Postal code"
            name="postcode"
            value={values.postcode}
            onChange={handleChange}
            margintop={'5px'}
          />
          <AddressInput
            helperText={touched.city && errors.city}
            error={!!errors.city && touched.city}
            label="City"
            name="city"
            value={values.city}
            onChange={handleChange}
            margintop={'5px'}
          />
        </DeliveryAddressBlock>
      </Block>
      <ButtonBlock>
        <HealtheraButton
          width="100px"
          height="35px"
          onClick={handleSubmit}
          disabled={!isValid}
        >
          Confirm
        </HealtheraButton>
      </ButtonBlock>
    </Container>
  );
};

const Container = styled(Box)``;

const Block = styled(Box)`
  border: 1px solid #BDBDBD;
  border-radius: 8px;
  width: 70%;
  margin: 30px auto;
  padding: 15px 20px;
`;

const ButtonBlock = styled(Box)`
  width: 75%;
  margin: 10px auto;
  display: flex;
  justify-content: flex-end;
`;

const BlockTitle = styled(Box)`
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 10px;
`;

const PharmacyName = styled(Box)`
  font-size: 12px;
  font-weight: 700;
`;

const OrganisationName = styled(Box)`
  font-size: 12px;
  font-weight: 400;
`;

const Postcode = styled(Box)`
  font-size: 12px;
  font-weight: 600;
  margin: 10px 0;
`;

const Address = styled(Box)`
  font-size: 12px;
  font-weight: 600;
`;

const DeliveryAddressBlock = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

const AddressInput = styled(InputField)`
  && {
    width: 48%;
  }
`;

export default DeliveryForm;
